function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-fill",
  width: 120,
  height: 81,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  "data-svg-class": "RoomButton-stroke",
  width: 119,
  height: 80,
  x: 0.5,
  y: 0.5,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M119.942 42.931L120 65H75.092c-5.244 0-10.184-1.705-14.289-4.932C55.21 55.674 52 49.088 52 41.999 52 29.318 62.359 19 75.092 19c10.761 0 20.245 7.59 22.55 18.049l.084.368c.955 3.108 3.814 5.355 7.119 5.514h15.097z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M119.443 43.431H104.82a8.384 8.384 0 01-7.581-5.901l-.086-.374C94.9 26.928 85.619 19.5 75.092 19.5 62.635 19.5 52.5 29.594 52.5 41.999c0 6.936 3.138 13.377 8.612 17.676 4.016 3.157 8.848 4.825 13.98 4.825h44.407l-.056-21.069z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M133 81v-5c-.687-6.242-6-11.107-12.431-11.107l-1.512.019L119 43.018l1.559-.018c18.516 0 33.66 14.675 34.412 33l.029 5h-22z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M133.5 80.5h20.997l-.026-4.48c-.744-18.112-15.72-32.52-33.906-32.52l-1.064.012.054 20.894 1.014-.013c6.64 0 12.209 5.012 12.931 11.607v4.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M84.999 42.184C84.9 47.597 80.415 52 75 52a9.89 9.89 0 01-6.187-2.145A9.95 9.95 0 0165 42C65 36.485 69.486 32 75 32c5.515 0 10 4.485 10 9.999l-.001.185z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M84.499 42.178l.001-.18c0-5.237-4.261-9.498-9.5-9.498-5.238 0-9.5 4.262-9.5 9.499a9.45 9.45 0 003.622 7.464A9.39 9.39 0 0075 51.5c5.142 0 9.404-4.183 9.499-9.322z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M11 27h14v24H11z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M11.5 27.5h13v23h-13z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M11 27h14v15H11z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M11.5 27.5h13v14h-13z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-fill",
  d: "M35 0h4v81h-4z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "RoomButton-stroke",
  d: "M35.5.5h3v80h-3z"
})));

function SvgRoomHvacAirHandler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 81,
    viewBox: "0 0 155 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomHvacAirHandler);
export default __webpack_public_path__ + "static/media/RoomHvacAirHandler.7fdb8f82.svg";
export { ForwardRef as ReactComponent };